// The creator's example texts follow the puzzle's theme: a Funny puzzle should
// not suggest «Where did we first meet?». Each theme can override these keys in
// `app.creator.themed.<theme>.*`; anything missing falls back to the generic
// `app.creator.*` copy, which is the romantic one.
export const THEMED_COPY_KEYS = [
  "question.placeholder",
  "question.ideas.met",
  "question.ideas.song",
  "question.ideas.trip",
  "question.ideas.joke",
  "hint.placeholder",
  "clueName.placeholder",
  "reveal.placeholder",
  "word.placeholder",
  "word.hintPlaceholder",
];

export function themedText(tr, theme, key) {
  return theme ? tr([`app.creator.themed.${theme}.${key}`, `app.creator.${key}`]) : tr(`app.creator.${key}`);
}
